import React from 'react';
import { string, bool, number, node, func } from 'prop-types';
import { noop } from 'lodash';
import { l_chevron_down, l_chevron_up } from '@fiverr-private/icons';
import { Icon } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { UNLIMITED_VALUES } from '../../../../utils/packagesUtils/constants';
import { CHEVRON_ICON_SIZE } from '../../constants';

const MilestoneHeader = ({ title, duration, revisions, expandedSteps, onStepsToggle = noop, price, milestoneNumber }) => {
    const chevronIcon = expandedSteps ? l_chevron_up : l_chevron_down;
    const isUnlimitedRevisions = UNLIMITED_VALUES.includes(revisions);
    const subtitleParams = { duration, revisions };
    const subTitleSuffix = isUnlimitedRevisions
        ? 'unlimited_revisions'
        : 'limited_revisions';
    const subTitleKey = `gig_page_perseus.workProcess.milestone.subtitle.${subTitleSuffix}`;
    const milestoneTitleKey = `gig_page_perseus.workProcess.milestone.title.${milestoneNumber}`;

    return (
        <div className="milestone-header">
            <div className="m-b-8">
                <strong className="tbody-5 milestone-title" onClick={onStepsToggle}>
                    <span>
                        <I18n k={milestoneTitleKey} params={{ title }}/>
                    </span>
                    <Icon className="expand-steps-icon" size={CHEVRON_ICON_SIZE}>
                        {chevronIcon}
                    </Icon>
                </strong>
                <div className="milestone-subtitle">
                    <I18n k={subTitleKey} params={subtitleParams}/>
                </div>
            </div>
            {price}
        </div>
    );
};

MilestoneHeader.propTypes = {
    title: string.isRequired,
    duration: number.isRequired,
    revisions: number.isRequired,
    expandedSteps: bool,
    onStepsToggle: func,
    price: node,
    milestoneNumber: number.isRequired
};

export default MilestoneHeader;
